import { useCallback, useSyncExternalStore } from 'react';

const getServerSnapshot = () => false;

/** Подписывается на CSS media query, отдаёт актуальное совпадение и реагирует на его смену. */
const useMedia = (query: string): boolean => {
  const subscribe = useCallback(
    (onStoreChange: () => void) => {
      const mediaQueryList = window.matchMedia(query);

      mediaQueryList.addEventListener('change', onStoreChange);

      return () => mediaQueryList.removeEventListener('change', onStoreChange);
    },
    [query]
  );

  const getSnapshot = useCallback(() => window.matchMedia(query).matches, [query]);

  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};

export default useMedia;
